// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061452/js/" + chunkId + "." + {"44":"67fa144c","225":"3f85c1da","481":"15955ffd","486":"0c80dc31","770":"8ddfdadc"}[chunkId] + ".0.14084782681731756.chunk.js";
};